import { useEffect } from 'react'

export default function useSyncRefValue(ref = { current: null }, value) {
  useEffect(() => {
    ref.current = value
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
}
